// Do not modify this file; it is autogenerated as part of build.
// Original content from the checked-in version has been overwritten after build
// The version stamped version is near consistent with the version value in package.json
// Versions prefixed with an asterisk (*version) were stamped without a bump, and could be stale
export const npmVersionNumber = '10.14.2'
